import React from 'react';

import { cacheRefetchUrlStateAtom } from '@/core/features/a-dynamic-page/hooks/use-dynamic-page-query-cache-handler';
import { useClientUrl, useLayoutId } from '@/core/features/app/app-atoms';
import { useAtomValue } from '@/core/features/store/atom-store';
import color from '@/core/features/styles/color';
import zIndex from '@/core/features/styles/generated/z-index';

export default function LoadingLayer() {
    const containerElementRef = React.useRef<HTMLDivElement>(null);
    const [clientUrl] = useClientUrl();
    const isCacheRefetch = useAtomValue(cacheRefetchUrlStateAtom) === clientUrl;
    const layoutId = useLayoutId();

    // hide loading layer on cache refetch or for S1 layouts
    if (isCacheRefetch || layoutId?.includes('S1')) {
        return null;
    }

    return (
        <>
            <div
                className={'loadingLayer block absolute inset-0 pointer-events-none overflow-hidden'}
                ref={containerElementRef}
                style={{ zIndex: zIndex('loadingLayer') }}
            />
            <style jsx>{`
                .loadingLayer {
                    mask-image: -webkit-radial-gradient(center, white, black);
                    background-color: ${color('white-016')};
                }
                .loadingLayer::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    transform: translateX(-100%);
                    animation: 1s ease-in-out infinite 0.5s normal none running shimmer;
                    will-change: transform;
                    background: linear-gradient(90deg, transparent, ${color('black-005')}, transparent);
                }
                @keyframes shimmer {
                    0% {
                        transform: translateX(-100%);
                    }
                    50% {
                        transform: translateX(100%);
                    }
                    100% {
                        transform: translateX(100%);
                    }
                }
            `}</style>
        </>
    );
}
